const observedFrames = new WeakMap();

const eventsForMonitorTurboFramesInitialization = ["turbo:load", "turbo:render", "turbo:frame-load", "equis:init:monitorTurboFrames"]
eventsForMonitorTurboFramesInitialization.forEach((eventName) => {
  document.addEventListener(eventName, monitorTurboFrames);
});

function monitorTurboFrames() {
  // Durch alle Turbo-Frames gehen und die gewünschte Ladeanimation hinzufügen, wenn das Frame gerade am laden ist
  // https://turbo.hotwired.dev/reference/attributes#automatically-added-attributes
  const checkFrames = () => {
    document.querySelectorAll("turbo-frame[data-loading-style]").forEach((frame) => monitorTurboFrameAriaBusyAttribute(frame));
  }

  checkFrames();

  // Es kann vorkommen, dass `document.querySelectorAll("turbo-frame[data-loading-style]")` direkt nach z.B. `turbo:frame-load` keine neuen Frames findet,
  // deswegen primitiv eine wiederholte Überprüfung
  setTimeout(checkFrames, 1000);
}

function monitorTurboFrameAriaBusyAttribute(frame) {
  if (observedFrames.has(frame)) return

  const addLoadingAnimationIfNeeded = () => {
    if (frame.getAttribute("aria-busy") === "true") {
      addLoadingAnimationToTurboFrame(frame);
    } else {
      removeLoadingAnimationFromTurboFrame(frame);
    }
  };

  // Initialzustand überprüfen
  // Wenn das Frame gerade am laden ist (durch z.B. ein asynchrones src-Attribute) wird von Anfang an eine Ladeanimation hinzugefügt
  addLoadingAnimationIfNeeded();

  // Wenn das frame zu einem späteren Zeitpunkt das Attribute aria-busy bekommt:
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === "aria-busy") {
        addLoadingAnimationIfNeeded();
      }
    });
  });

  observer.observe(frame, { attributes: true });
  observedFrames.set(frame, observer);
}

function addLoadingAnimationToTurboFrame(frame) {
  switch (frame.dataset.loadingStyle) {
    case "spinner-initial":
      if (!frame.hasAttribute('complete')) {
        addSpinnerToElement(frame);
      }
      break;
    case "spinner":
      addSpinnerToElement(frame);
      break;
    case "opacity":
      addOpacityToElement(frame);
      break;
    case "overlay-spinner":
      addOverlaySpinnerToElement(frame)
      break
    default:
      console.warn("No loading style defined for turbo-frame", frame);
  }
}

function removeLoadingAnimationFromTurboFrame(frame) {
  switch (frame.dataset.loadingStyle) {
    case "opacity":
      addOpacityToElement(frame, 1);
      break;
    case "overlay-spinner":
      removeOverlaySpinnerFromElement(frame)
      break
  }
}

function addSpinnerToElement(element) {
  let extraClasses = "";
  if (element.hasAttribute("data-loading-class")) {
    extraClasses = element.getAttribute("data-loading-class");
  }
  element.innerHTML = spinnerHTML(extraClasses)
}

function addOpacityToElement(element, opacity = 0.5) {
  element.style.opacity = opacity;
}

function addOverlaySpinnerToElement(frame) {
  if (frame.querySelector(".frame-overlay-spinner") || document.querySelector(".viewport-overlay-spinner")) return

  let extraClasses = ""
  if (frame.hasAttribute("data-loading-class")) {
    extraClasses = frame.getAttribute("data-loading-class")
  }

  const frameRect = frame.getBoundingClientRect()
  const isTopVisible = frameRect.top >= 0 && frameRect.top < window.innerHeight
  const isBottomVisible = frameRect.bottom > 0 && frameRect.bottom <= window.innerHeight
  const isPartiallyVisible = isTopVisible || isBottomVisible

  const spinnerVisibleInViewport = isPartiallyVisible && frameRect.height < window.innerHeight * 1.5

  if (spinnerVisibleInViewport) {
    frame.style.position = "relative"
    const overlay = document.createElement("div")
    overlay.className = `frame-overlay-spinner ${extraClasses}`
    overlay.innerHTML = spinnerHTML()
    frame.appendChild(overlay)
  } else {
    const overlay = document.createElement("div")
    overlay.className = `viewport-overlay-spinner ${extraClasses}`
    overlay.innerHTML = spinnerHTML()
    document.body.appendChild(overlay)
  }
}

function removeOverlaySpinnerFromElement(frame) {
  const frameSpinner = frame.querySelector(".frame-overlay-spinner")
  if (frameSpinner) frameSpinner.remove()

  const viewportSpinner = document.querySelector(".viewport-overlay-spinner")
  if (viewportSpinner) viewportSpinner.remove()
}

function spinnerHTML(extraClasses) {
  return `
    <div class='d-flex justify-content-center align-content-center p-3 ${extraClasses}'>
      <div class='spinner-border text-primary' role='status'><span class='visually-hidden'>Loading...</span></div>
    </div>
  `
}

export { addSpinnerToElement };
